module.exports = __webpack_public_path__ + "static/media/solution24.a185cede.jpg";